import { useEffect, useState } from 'react';
import { supabase } from '../supabase';


export function useBills() {
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(true);


    const fetchBills = async () => {
        setLoading(true);
        const { data, error } = await supabase
            .from('bill_extracts')
            .select('*')
            .order('created_at', { ascending: false });

        if (!error) setBills(data);
        setLoading(false);
    };


    useEffect(() => {
        fetchBills();
    }, []);

    return { bills, loading, fetchBills };
}
